import { Box, useMediaQuery, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, SIDEBAR_WIDTH, SIDEBAR_MINI } from '@/components/organisms/Sidebar';
import { TopBar } from '@/components/organisms/TopBar';
import { FloatingButton } from '@/components/organisms/FloatingButton';
import { useAuth } from '@/store/AuthContext';

export function AdminLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { selectedBranch } = useAuth();

  const [sidebarOpen, setSidebarOpen]     = useState(true);
  const [mobileOpen, setMobileOpen]       = useState(false);

  const sidebarW = !isMobile && sidebarOpen ? SIDEBAR_WIDTH : SIDEBAR_MINI;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Sidebar
        open={sidebarOpen}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          ml: { md: `${sidebarW}px` },
          transition: 'margin-left 0.2s ease',
          minWidth: 0,
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 32,
            right: 24,
            width: 220,
            height: 220,
            borderRadius: '50%',
            background: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.12),
            filter: 'blur(56px)',
            pointerEvents: 'none',
          },
        }}
      >
        <TopBar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen((p) => !p)}
          onMobileMenuOpen={() => setMobileOpen(true)}
        />

        <Box
          sx={{
            flex: 1,
            // Mobile TopBar is 52 px tall + 12 px top offset + 4 px gap = 68 px.
          // Desktop TopBar is 72 px tall + 12 px offset = 84 px → use layout constant.
          mt: { xs: '68px', md: `${theme.custom.layout.topbarHeight}px` },
            pt: { xs: 1.5, sm: theme.custom.layout.contentTopGap },
            px: { xs: 2.5, sm: 3.5, lg: 4.5 },
            pb: { xs: theme.custom.layout.sectionGap, sm: theme.custom.layout.sectionGap + 1 },
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: theme.custom.layout.contentMaxWidth,
              mx: 'auto',
              position: 'relative',
              zIndex: 1,
            }}
            key={selectedBranch || 'default-branch'}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>

      {/* Floating action button — persists across all page navigations */}
      <FloatingButton />
    </Box>
  );
}

